// src/components/img/GalerySectionVessels/VesselHector.tsx
import React from 'react';
import vesselImage from './hector.jpeg';

const VesselHector: React.FC = () => (
  <img src={vesselImage} alt="Vessel Hector" />
);

export default VesselHector;